// mutations
const SET_PAGINATION = (state, payload) => {
  state.page = payload;
};
const SET_PAGESIZE = (state, payload) => {
  state.page_size = payload;
};
const SET_RESNEWS = (state, payload) => {
  state.res_news = payload;
};
const SET_RESNEWSDETAIL = (state, payload) => {
  state.res_newsDetail = payload;
};
const SET_DATANEWS = (state, payload) => {
  state.dataNews = payload;
};
const SET_NAMESLUG = (state, payload) => {
  state.nameSlug = payload;
};
const SET_RESSLUG = (state, payload) => {
  state.slug = payload;
};
const SET_RESGENERATOR = (state, payload) => {
  state.resGenerator = payload;
};
const SET_IDNEWS = (state, payload) => {
  state.idNews = payload;
};
const SET_RESMASTERNEWS = (state, payload) => {
  state.res_master_news = payload;
};

export default {
  SET_RESMASTERNEWS,
  SET_PAGINATION,
  SET_RESNEWS,
  SET_RESNEWSDETAIL,
  SET_PAGESIZE,
  SET_NAMESLUG,
  SET_DATANEWS,
  SET_RESSLUG,
  SET_RESGENERATOR,
  SET_IDNEWS
};
